 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLEBB from '@/components/xhtml/EBB'
 import XHTMLTLU from '@/components/xhtml/TLU'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLFM from '@/components/xhtml/FM'
 import XHTMLAUTHOR_NOTE from '@/components/xhtml/author_note'
 import XHTMLMAP from '@/components/xhtml/map'
 import XHTMLPROLOGUE from '@/components/xhtml/Prologue'
 import XHTMLPART1 from '@/components/xhtml/Part1'
 import XHTMLCHAPTER_01 from '@/components/xhtml/Chapter_01'
 import XHTMLCHAPTER_02 from '@/components/xhtml/Chapter_02'
 import XHTMLPART2 from '@/components/xhtml/Part2'
 import XHTMLCHAPTER_03 from '@/components/xhtml/Chapter_03'
 import XHTMLCHAPTER_04 from '@/components/xhtml/Chapter_04'
 import XHTMLCHAPTER_05 from '@/components/xhtml/Chapter_05'
 import XHTMLCHAPTER_06 from '@/components/xhtml/Chapter_06'
 import XHTMLCHAPTER_07 from '@/components/xhtml/Chapter_07'
 import XHTMLCHAPTER_08 from '@/components/xhtml/Chapter_08'
 import XHTMLCHAPTER_09 from '@/components/xhtml/Chapter_09'
 import XHTMLCHAPTER_10 from '@/components/xhtml/Chapter_10'
 import XHTMLCHAPTER_11 from '@/components/xhtml/Chapter_11'
 import XHTMLPART3 from '@/components/xhtml/Part3'
 import XHTMLCHAPTER_12 from '@/components/xhtml/Chapter_12'
 import XHTMLCHAPTER_13 from '@/components/xhtml/Chapter_13'
 import XHTMLCHAPTER_14 from '@/components/xhtml/Chapter_14'
 import XHTMLPART4 from '@/components/xhtml/Part4'
 import XHTMLCHAPTER_14A from '@/components/xhtml/Chapter_14a'
 import XHTMLCHAPTER_15 from '@/components/xhtml/Chapter_15'
 import XHTMLCHAPTER_16 from '@/components/xhtml/Chapter_16'
 import XHTMLCHAPTER_17 from '@/components/xhtml/Chapter_17'
 import XHTMLPART5 from '@/components/xhtml/Part5'
 import XHTMLCHAPTER_18 from '@/components/xhtml/Chapter_18'
 import XHTMLCHAPTER_19 from '@/components/xhtml/Chapter_19'
 import XHTMLCHAPTER_20 from '@/components/xhtml/Chapter_20'
 import XHTMLCHAPTER_21 from '@/components/xhtml/Chapter_21'
 import XHTMLCHAPTER_22 from '@/components/xhtml/Chapter_22'
 import XHTMLCHAPTER_23 from '@/components/xhtml/Chapter_23'
 import XHTMLCHAPTER_24 from '@/components/xhtml/Chapter_24'
 import XHTMLPART6 from '@/components/xhtml/Part6'
 import XHTMLCHAPTER_25 from '@/components/xhtml/Chapter_25'
 import XHTMLCHAPTER_26 from '@/components/xhtml/Chapter_26'
 import XHTMLCHAPTER_27 from '@/components/xhtml/Chapter_27'
 import XHTMLCHAPTER_28 from '@/components/xhtml/Chapter_28'
 import XHTMLCHAPTER_29 from '@/components/xhtml/Chapter_29'
 import XHTMLCHAPTER_30 from '@/components/xhtml/Chapter_30'
 import XHTMLCHAPTER_31 from '@/components/xhtml/Chapter_31'
 import XHTMLPART7 from '@/components/xhtml/Part7'
 import XHTMLCHAPTER_32 from '@/components/xhtml/Chapter_32'
 import XHTMLCHAPTER_33 from '@/components/xhtml/Chapter_33'
 import XHTMLCHAPTER_34 from '@/components/xhtml/Chapter_34'
 import XHTMLCHAPTER_35 from '@/components/xhtml/Chapter_35'
 import XHTMLCHAPTER_36 from '@/components/xhtml/Chapter_36'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLEPILOGUE from '@/components/xhtml/Epilogue'
 import XHTMLGALLERY from '@/components/xhtml/Gallery'
 import XHTMLACKNOW from '@/components/xhtml/acknow'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLAUTHOR from '@/components/xhtml/Author'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLAUBA from '@/components/xhtml/auba'
 import XHTMLORIMAD from '@/components/xhtml/ORIMad'
 import XHTMLCREEPY from '@/components/xhtml/creepy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Cover",
 			"name" : "xhtml/Cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/EBB",
 			"name" : "xhtml/EBB",
 			"component" : XHTMLEBB
 		},
 		{
 			"path" : "/xhtml/TLU",
 			"name" : "xhtml/TLU",
 			"component" : XHTMLTLU
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/Title",
 			"name" : "xhtml/Title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/FM",
 			"name" : "xhtml/FM",
 			"component" : XHTMLFM
 		},
 		{
 			"path" : "/xhtml/author_note",
 			"name" : "xhtml/author_note",
 			"component" : XHTMLAUTHOR_NOTE
 		},
 		{
 			"path" : "/xhtml/map",
 			"name" : "xhtml/map",
 			"component" : XHTMLMAP
 		},
 		{
 			"path" : "/xhtml/Prologue",
 			"name" : "xhtml/Prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/Part1",
 			"name" : "xhtml/Part1",
 			"component" : XHTMLPART1
 		},
 		{
 			"path" : "/xhtml/Chapter_01",
 			"name" : "xhtml/Chapter_01",
 			"component" : XHTMLCHAPTER_01
 		},
 		{
 			"path" : "/xhtml/Chapter_02",
 			"name" : "xhtml/Chapter_02",
 			"component" : XHTMLCHAPTER_02
 		},
 		{
 			"path" : "/xhtml/Part2",
 			"name" : "xhtml/Part2",
 			"component" : XHTMLPART2
 		},
 		{
 			"path" : "/xhtml/Chapter_03",
 			"name" : "xhtml/Chapter_03",
 			"component" : XHTMLCHAPTER_03
 		},
 		{
 			"path" : "/xhtml/Chapter_04",
 			"name" : "xhtml/Chapter_04",
 			"component" : XHTMLCHAPTER_04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js